import { SelectButton } from "primereact/selectbutton";
import React from "react";
import { OperationOptions, Operations } from "../Constants.ts";
import { labelFor } from "../Labels.ts";
import { fitOneDigitRanges } from "../FactRanges.ts";
import { fitFactLevel } from "../FactLevels.ts";
import { useSetting, useSettingsActions } from "./SettingsStore.tsx";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
//import { DefaultSettings } from "../Models.ts";

export const Operators = React.memo(function Operators() {
    const {getSettings, setSettings} = useSettingsActions();
    const {selected, allOperations, page, language} = useSetting((settings) => ({
        selected: settings.Operators?.map((operator) => operator.value),
        allOperations: settings.AllOperations,
        page: settings.Page,
        language: settings.Language,
    }));
    const t = useTranslation();
    // OperationOptions carries `value` for the URL/setting and `sign` for the
    // arithmetic symbol - neither is the on-screen label (ADR 0051 §3), so a
    // `label` is added here rather than folded into either of those fields.
    var visibleOperations = (allOperations ?
        OperationOptions : OperationOptions.filter((operator) => operator.value === page))
        .map((operator) => ({ ...operator, label: labelFor(operator.value, language) }));

    function handleOperatorSelection(values) {
        let updatedSettings = JSON.parse(JSON.stringify(getSettings()));

        const longDivisionOperatorSelected = values.includes(Operations.LongDivision.valueOf());
        if (longDivisionOperatorSelected) {        
            const lastAddedOperator = values[values.length - 1];
            //const defaultRange = DefaultSettings.NumberRanges[0].NumberRange.map((number) => number);
            if (lastAddedOperator === Operations.LongDivision.valueOf()) {
                values = [lastAddedOperator];
                // if (updatedSettings.NumberRanges[0].NumberOfDigits === 1) {
                //     defaultRange.shift();
                //     updatedSettings.NumberRanges[0].NumberRange = defaultRange;
                //     const numberSelection = updatedSettings.NumberRanges[0].NumberRangeSelection;
                //     const zeroIndex = numberSelection.findIndex(x => x === 0);
                //     if (zeroIndex >= 0) {
                //         numberSelection.splice(zeroIndex, 1);
                //         updatedSettings.NumberRanges[0].NumberRangeSelection = numberSelection;
                //     }
                // }
            } else {
                values = values.filter((operator) => operator !== Operations.LongDivision.valueOf());

                // if (updatedSettings.NumberRanges[0].NumberOfDigits === 1) {
                    
                //     updatedSettings.NumberRanges[0].NumberRange = defaultRange;
                // }
            }            
        }

        updatedSettings.Operators = OperationOptions.filter((operator) => values.includes(operator.value));
        // A multiplication/division sheet offers 0-12 where any other offers
        // 0-9, so the one-digit ranges follow the operations (ADR 0064 §3).
        // A fact level follows them too: level 10 of x is past the end of +
        // (ADR 0071 §5).
        setSettings(fitFactLevel(fitOneDigitRanges(updatedSettings)));
    }

    return (
        <div className='operatorsContainer'>
            <SelectButton 
                value={selected} 
                onChange={(e) => handleOperatorSelection(e.value)}
                optionLabel="label"
                options={visibleOperations}
                multiple
                className='select operators'
                aria-label={t('settings.operationsToIncludeAria')}
            />
        </div>
    );
});